import { motion, Variants } from "framer-motion";
import styled from "styled-components";
import dynamic from "next/dynamic";
import { useState } from "react";
const CardVideoPlayer = dynamic(() => import("@/components/VideoSlider/CardVideoPlayer"), { ssr: false });

const VideoSliderItemWrapper = styled(motion.div)<{ $active: boolean }>`
  //overflow: hidden;

  height: 500px;
  position: relative;
  flex: 1;
  cursor: ${({ $active }) => ($active ? "default" : "pointer")};
`;

const VideoSliderInfo = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: absolute;
  bottom: -54px;
  left: 24px;
  right: 0;
  min-width: 700px;
`;

const VideoSliderInfoTitle = styled(motion.div)`
  color: #d0d6e0;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
`;

const VideoSliderInfoDescription = styled(motion.div)`
  color: #8a8f98;
  font-size: 14px;
  font-weight: 400;
  line-height: 11px;
`;

const VideoPreviewInfo = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
`;

const MetaThumbnail = styled(motion.div)`
  width: 36px;
  height: 36px;
  border-radius: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MetaLabel = styled(motion.div)`
  color: #f7f8f8;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export default function VideoSliderItem({
  videoItem,
  active,
  setActiveIndex,
  index,
  handleProgression,
  muted,
  setMuted,
}) {
  const [hovered, setHovered] = useState(false);

  const PreviewVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delay: 0.2,
        duration: 0.7,
      },
    },
  };

  const ContainerVariants: Variants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.05,
        delayChildren: 0.2,
        staggerDirection: -1,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 5 },
    visible: { opacity: 1, y: 0 },
  };

  const transition = {
    type: "spring",
    restSpeed: 0.01,
    mass: 1,
    damping: 23,
    velocity: 25,
    stiffness: 380,
  };

  const CardWrapperAnimations = {
    collapsed: {
      flex: 1,
    },
    hovered: {
      flex: 1.5,
    },
    expanded: {
      flex: 6,
      transition: transition,
    },
  };

  return (
    <VideoSliderItemWrapper
      $active={active}
      layout
      variants={CardWrapperAnimations}
      layoutId={`video-slider-item-${index}`}
      initial={active ? "expanded" : "collapsed"}
      animate={active ? "expanded" : hovered ? "hovered" : "collapsed"}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      onClick={() => {
        setActiveIndex(index);
      }}>
      <CardVideoPlayer
        videoItem={videoItem}
        active={active}
        handleProgression={handleProgression}
        muted={muted}
        setMuted={setMuted}
        hovered={hovered}
      />
      <VideoPreviewInfo
        variants={PreviewVariants}
        initial={!active ? "visible" : "hidden"}
        animate={!active ? "visible" : "hidden"}>
        <MetaThumbnail>
          <img src={videoItem?.avatar?.filename} alt='thumbnail' />
        </MetaThumbnail>
        <MetaLabel>{videoItem.previewTitle}</MetaLabel>
      </VideoPreviewInfo>
      <VideoSliderInfo
        variants={ContainerVariants}
        initial={active ? "visible" : "hidden"}
        animate={active ? "visible" : "hidden"}>
        <VideoSliderInfoTitle variants={itemVariants}>{videoItem.title}</VideoSliderInfoTitle>
        <VideoSliderInfoDescription variants={itemVariants}>{videoItem.subtitle}</VideoSliderInfoDescription>
      </VideoSliderInfo>
    </VideoSliderItemWrapper>
  );
}
